import React from 'react';
import { useAppDispatch } from '../../app/redux/useAppSelector';
import { MenuItem, MenuSeparator } from '../../components/Menu';
import type { DocumentType } from '../../graphql/generated/gql';
import { gql } from '../../graphql/generated/gql';
import archiveIcon from '../../icons/non-prefilled/16x16/archive.svg';
import linkIcon from '../../icons/non-prefilled/16x16/link.svg';
import useToggleArchived from '../../post/useToggleArchived';
import { miscToasts } from '../../toasts/toasts';
import { UIActions } from '../../ui/uiSlice';
import fullOrgUrl from '../../utils/url/fullOrgUrl';
import postPath from '../../utils/url/postPath';

const TOPIC_POST_OVERFLOW_MENU_CONTENT_POST_FRAGMENT = gql(`
  fragment TopicPostOverflowMenuContent_post on SlimPostFields {
    id
    ...postPath_post
    ...useToggleArchived_post
  }
`);

interface TopicPostOverflowMenuContentProps {
  post: DocumentType<typeof TOPIC_POST_OVERFLOW_MENU_CONTENT_POST_FRAGMENT>;
  extraMenuItems?: React.ReactNode;
  canEditPost: boolean;
  refetch?: () => void;
}

const TopicPostOverflowMenuContent = ({
  post,
  extraMenuItems,
  canEditPost,
  refetch,
}: TopicPostOverflowMenuContentProps) => {
  const dispatch = useAppDispatch();
  const toggleArchived = useToggleArchived();

  const handleCopy = async () => {
    await navigator.clipboard.writeText(fullOrgUrl(postPath(post)));
    dispatch(UIActions.pushToast(miscToasts.linkCopied));
  };

  return (
    <>
      <MenuItem icon={linkIcon} onClick={handleCopy}>
        Copy Link
      </MenuItem>
      {extraMenuItems}
      {canEditPost && (
        <>
          <MenuSeparator />
          <MenuItem
            icon={archiveIcon}
            onClick={() => {
              toggleArchived(post, { onComplete: refetch });
            }}
          >
            {post.archivedAt ? 'Unarchive' : 'Archive'}
          </MenuItem>
        </>
      )}
    </>
  );
};

export default TopicPostOverflowMenuContent;
